module.exports = __webpack_public_path__ + "static/media/gameUniversity.8341620b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniversity.png
// module id = 2272
// module chunks = 0